import React from 'react';

import './index.less';
import ErrorImg from 'Static/images/404.png';

const Error = () => (
  <div className="error-page">
    <img src={ErrorImg} alt="" />
  </div>
);

export default Error;
